<section class="sales-blueprint">

  <h2 id="product-sales-title" class="container">Espelho de vendas</h2>

  <div class="scrollable-container">
    <div class="row" *ngFor="let row of data.sales_blueprint">

      <div class="col">
        <p>{{row.title}}</p>
      </div>

      <div class="col" *ngFor="let col of row.values">
        <p>{{col.unit_number}}</p>
        <p>{{col.area}}m² 4V</p>
        <p>{{col.status}}</p>
        <p [class]="col.status">{{col.value.currency}} {{col.value.value | number}}</p>
        <span class="dots"></span>
      </div>

    </div>
  </div>
</section>